import { t } from 'i18next'

export class VendedorValidator {
  private readonly vendedorId: string
  private readonly possuiDadosDeComissao: boolean

  constructor({ vendedorId, possuiDadosDeComissao }: { vendedorId: string; possuiDadosDeComissao: boolean }) {
    this.vendedorId = vendedorId
    this.possuiDadosDeComissao = possuiDadosDeComissao
  }

  validate(): string | null {
    if (!this.vendedorId) {
      return t('proposta:informacoes_iniciais.cards.vendedor.required')
    }

    if (this.vendedorId && !this.possuiDadosDeComissao) {
      return t('proposta:informacoes_iniciais.cards.vendedor.sem_comissao')
    }

    return null
  }
}
